import { render } from "./PreselectTabs.vue?vue&type=template&id=baada1e0&scoped=true"
import script from "./PreselectTabs.vue?vue&type=script&lang=js"
export * from "./PreselectTabs.vue?vue&type=script&lang=js"

import "./PreselectTabs.vue?vue&type=style&index=0&id=baada1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baada1e0"]])

export default __exports__